import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

// Phone Headcount: one compact card per function with the persons number big
// on the right, the grand total first so it is seen without scrolling.
export default function HeadcountMobile({ vm }) {
  const { loading, perFunction, grand, isTwoSided } = vm;
  return (
    <div>
      <div className="page-head"><h1>Headcount</h1></div>
      <div className="ev-hc-intro">Expected persons per function, deduped by mobile. Tap a function for its guests.</div>
      {loading ? <div className="card card-pad"><Spinner /></div>
        : perFunction.length === 0 ? <div className="card card-pad empty">No functions yet.</div> : (
          <div className="mobile-card-list">
            <div className="card card-pad mobile-record-card ev-m-card">
              <div className="mobile-card-head" style={{ alignItems: 'baseline' }}>
                <strong className="mobile-title">All functions</strong>
                <div style={{ flex: 1 }} />
                <span className="ev-m-big" style={{ fontSize: 26 }}>{grand.persons}</span>
              </div>
              <div className="ev-m-line muted">{grand.parties} parties · person-visits (counted at each function)</div>
            </div>
            {perFunction.map(({ fn, parties, persons, extra, bySide }) => (
              <div key={fn.FunctionId} className="card card-pad mobile-record-card ev-m-card row-link" onClick={() => vm.openRow(fn)}>
                <div className="mobile-card-head" style={{ alignItems: 'baseline' }}>
                  <strong className="mobile-title">{fn.FunctionName}</strong>
                  <div style={{ flex: 1 }} />
                  <span className="ev-m-big" style={{ fontSize: 26 }}>{persons}</span>
                </div>
                <div className="ev-m-line muted">
                  <span>{fmtDate(fn.FunctionDate)}{fn.FunctionTime ? ` · ${fmtTime(fn.FunctionTime)}` : ''}</span>
                  <span>· {parties} parties</span>
                  {extra > 0 && <span>· incl. {extra} extra-card</span>}
                </div>
                {isTwoSided && (
                  <div className="ev-m-line">
                    <span className="chip male">Groom {bySide.Groom}</span>
                    <span className="chip female">Bride {bySide.Bride}</span>
                    <span className="chip">Common {bySide.Common}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
